import React, { useState } from 'react';

import {
  FaPlane,
  FaHotel,
  FaBus,
  FaUsers,
  FaExchangeAlt,
  FaTrain,
  FaShip,
  FaUmbrella,
  FaSimCard,
  FaGlobeEurope
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

  
function ApplicationForm() {
  // ✅ CONTROL HERE
  const enabledTabs = ['packages']; // 🔥 change anytime

  const isEnabled = (tab) => enabledTabs.includes(tab);

  const [activeTab, setActiveTab] = useState('packages');
  const [isPakageOpen, setIsPakageOpen] = useState(false);

  const handleTabClick = (tab) => {
    if (isEnabled(tab)) setActiveTab(tab);
  };

  const [from, setFrom] = useState({
    city: 'Delhi',
    code: 'DEL, Delhi Indira Gandhi Intl'
  });
  const [to, setTo] = useState({
    city: 'Mumbai',
    code: 'BOM, Chhatrapati Shivaji'
  });

  const today = new Date();
  const twoDaysLater = new Date();
  twoDaysLater.setDate(today.getDate() + 2);

  const formatDate = (date) => {
    return date.toISOString().split('T')[0];
  };

  const [departureDate, setDepartureDate] = useState(formatDate(today));
  const [returnDate, setReturnDate] = useState(formatDate(twoDaysLater));
  const navigate = useNavigate();

  const tabClass = (tab, color) => `
    flex items-center gap-1
    ${isEnabled(tab) ? 'cursor-pointer' : 'opacity-50 cursor-not-allowed'}
    ${activeTab === tab && isEnabled(tab) ? color + ' font-bold' : ''}
  `;
  const handleSwap = () => {
    setFrom(to);
    setTo(from);
  };

  const categories = [
    { label: 'Domestic Packages', path: '/domestic-pakages' },
    { label: 'Pan India Hotels', path: '/pan-india-hotels' },
    { label: 'International Packages', path: '/international-pakages' },
    { label: 'Religious Packages', path: '/religious-pakages' },
    { label: 'Europe Packages', path: '/europe-pakages' }
  ];

  return (
    <>
      <div className="bg-[#246e73] w-full p-5 flex flex-col justify-center mt-6 items-center relative">
        <div className="relative z-20 md:-mb-6 -mb-3">
          <div className="flex flex-wrap gap-3 md:gap-3 shadow-lg bg-white text-gray-800 px-4 py-4 rounded-xl font-medium text-[15px]">
            <div onClick={() => handleTabClick('flights')} className={tabClass('flights','text-green-600')}>
          <FaPlane /> FLIGHT
        </div>
             <div onClick={() => handleTabClick('hotels')} className={tabClass('hotels','text-blue-600')}>
          <FaHotel /> HOTELS
        </div>

        {/* ✅ Packages */}
        <div
          className="relative"
          onMouseEnter={() => isEnabled('packages') && setIsPakageOpen(true)}
          onMouseLeave={() => setIsPakageOpen(false)}
        >
          <div
            onClick={() => isEnabled('packages') && setActiveTab('packages')}
            className={tabClass('packages','text-pink-600')}
          >
            <FaUmbrella /> PACKAGES
          </div>

          {isPakageOpen && isEnabled('packages') && (
            <div className="absolute bg-white border shadow rounded w-48">
              {categories.map((c,i)=>(
                <div key={i} onClick={()=>navigate(c.path)} className="p-2 hover:bg-gray-100 cursor-pointer">
                  {c.label}
                </div>
              ))}
            </div>
          )}
        </div>

        <div onClick={() => handleTabClick('bus')} className={tabClass('bus','text-yellow-600')}>
          <FaBus /> BUS
        </div>

        <div onClick={() => handleTabClick('group')} className={tabClass('group','text-purple-600')}>
          <FaUsers /> INSURANCE
        </div>

        <div onClick={() => isEnabled('sim') && navigate('/international-sim')} className={tabClass('sim','text-purple-600')}>
          <FaSimCard /> SIM
        </div>

        <div onClick={() => isEnabled('visa') && navigate('/visa')} className={tabClass('visa','text-red-600')}>
          <FaGlobeEurope /> VISA
        </div>

        <div onClick={() => handleTabClick('train')} className={tabClass('train','text-blue-600')}>
          <FaTrain /> TRAIN
        </div>

        <div onClick={() => handleTabClick('cruise')} className={tabClass('cruise','text-red-600')}>
          <FaShip /> CRUISE
        </div>

          </div>
        </div>

        <div className="flex flex-col gap-4 py-6 md:py-10 bg-white rounded-lg px-4 md:px-10 w-full max-w-5xl relative z-10">
          {activeTab === 'flights' && (
            <>
              <div className="flex flex-col md:flex-row md:justify-between gap-3">
                <div className="flex gap-2 text-sm font-medium text-gray-700">
                  <span className="cursor-pointer border border-red-900 py-1 px-2 rounded-full hover:bg-red-800 hover:text-white">
                    One Way
                  </span>
                  <span className="cursor-pointer border border-red-900 py-1 px-2 rounded-full hover:bg-red-800 hover:text-white">
                    Round Trip
                  </span>
                  <span className="cursor-pointer border border-red-900 py-1 px-2 rounded-full hover:bg-red-800 hover:text-white">
                    Multi City
                  </span>
                </div>
                <p className="text-gray-600 font-medium text-sm md:text-base">
                  Book Domestic and International Flight
                </p>
              </div>

              <div className="flex flex-col md:flex-row md:flex-nowrap gap-4 relative">
                <div className="flex-1 p-4 border border-gray-200 rounded-md md:rounded-l-md bg-white">
                  <p className="text-sm">From</p>
                  <h2 className="text-xl md:text-2xl font-bold">{from.city}</h2>
                  <p className="text-sm">{from.code}</p>
                </div>

                <div className="flex-1 p-4 border border-gray-200 rounded-md md:rounded-r-md bg-white">
                  <p className="text-sm">To</p>
                  <h2 className="text-xl md:text-2xl font-bold">{to.city}</h2>
                  <p className="text-sm">{to.code}</p>
                </div>

                <div
                  className="absolute hidden md:top-1/2 md:block md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 top-[60%] left-[50%] -translate-x-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow-md cursor-pointer hover:bg-gray-100"
                  onClick={handleSwap}
                >
                  <FaExchangeAlt className="text-gray-500 text-md" />
                </div>
              </div>

              <div className="flex flex-col md:flex-row gap-4">
                <div className="flex-1 p-4 border border-gray-200 rounded-md">
                  <p className="text-sm">Departure</p>
                  <input
                    type="date"
                    value={departureDate}
                    onChange={(e) => setDepartureDate(e.target.value)}
                    className="w-full text-xl md:text-2xl font-semibold outline-none"
                  />
                </div>

                <div className="flex-1 p-4 border border-gray-200 rounded-md">
                  <p className="text-sm">Return</p>
                  <input
                    type="date"
                    value={returnDate}
                    onChange={(e) => setReturnDate(e.target.value)}
                    className="w-full text-xl md:text-2xl font-semibold outline-none"
                  />
                </div>
                <div className="flex-1 p-4 border border-gray-200 rounded-md">
                  <p className="text-sm">TRAVELLER & CLASS</p>
                  <h2 className="text-base font-bold">1 Traveller & Economy</h2>
                </div>
              </div>
            </>
          )}
            {/* 🌴 Packages */}
        {activeTab === 'packages' && isEnabled('packages') && (
          <div className="text-center">
            <h2 className="text-xl font-bold">Explore Packages</h2>
            <p>Select category from above</p>
          </div>
        )}
          {activeTab === 'hotels' && (
            <div className="flex flex-wrap gap-4">
              <div className="p-4 border border-gray-200 rounded-md">
                <p className="text-sm">City / Location</p>
                <h2 className="text-xl md:text-2xl font-bold">Mumbai</h2>
                <p className="text-sm">Choose your hotel location</p>
              </div>
              <div className="flex-1 p-4 border border-gray-200 rounded-md">
                <p className="text-sm">Check-in</p>
                <input
                  type="date"
                  value={departureDate}
                  onChange={(e) => setDepartureDate(e.target.value)}
                  className="w-full text-xl md:text-2xl font-semibold outline-none"
                />
              </div>

              <div className="flex-1 p-4 border border-gray-200 rounded-md">
                <p className="text-sm">Check-Out</p>
                <input
                  type="date"
                  value={returnDate}
                  onChange={(e) => setReturnDate(e.target.value)}
                  className="w-full text-xl md:text-2xl font-semibold outline-none"
                />
              </div>
              <div className="p-4 border border-gray-200 rounded-md">
                <p className="text-sm">Guests</p>
                <h2 className="text-base font-bold">2 Adults, 1 Room</h2>
              </div>
            </div>
          )}

          {activeTab === 'bus' && (
            <div className="flex gap-4">
              <div className="flex-1 p-4 border border-gray-200 rounded-md">
                <p className="text-sm">From</p>
                <h2 className="text-xl md:text-2xl font-bold">Delhi</h2>
              </div>

              <div className="flex-1 p-4 border border-gray-200 rounded-md">
                <p className="text-sm">To</p>
                <h2 className="text-xl md:text-2xl font-bold">Jaipur</h2>
              </div>

              <div className="flex-1 p-4 border border-gray-200 rounded-md">
                <p className="text-sm">Date</p>
                <h2 className="text-xl md:text-2xl font-bold">16 Sep'25</h2>
              </div>
            </div>
          )}

          {activeTab === 'group' && (
            <div className="flex gap-4">
              <div className="p-4 border flex-1 border-gray-200 rounded-md">
                <p className="text-sm">Destination</p>
                <h2 className="text-xl md:text-2xl font-bold">Kerala</h2>
                <p className="text-sm">Plan your group trip</p>
              </div>
              <div className="p-4 border flex-1 border-gray-200 rounded-md">
                <p className="text-sm">Group Size</p>
                <h2 className="text-xl md:text-2xl font-bold">15 People</h2>
              </div>
            </div>
          )}
        </div>
      {activeTab !== 'packages' && (
        <div className="relative z-20 md:-mt-6 -mt-4">
          <div className="flex flex-wrap gap-3 md:gap-5 shadow-lg bg-green-600 text-white px-6 py-3 rounded-xl font-medium cursor-pointer">
            {activeTab === 'flights' && 'Search Flights'}
            {activeTab === 'hotels' && 'Search Hotels'}
            {activeTab === 'bus' && 'Search Bus'}
            {activeTab === 'group' && 'Search Group Trips'}
          </div>
        </div>
      )}


      </div>
    </>
  );
}

export default ApplicationForm;
